"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.BrokerType = exports.CommunicationPreferenceType = exports.RestrictedEffectiveDateEffectiveMonth = exports.RestrictedEffectiveDateStatus = exports.RestrictedEffectiveDateEnrollmentSource = exports.RestrictedPeriodType = exports.Format = exports.Transmission = exports.FileSchedule = exports.FileType = exports.ReviewType = exports.EnrollmentConfigFrequency = exports.EnrollmentMarketingSiteType = exports.EnrollmentConfigDefaultEnrollmentMethod = exports.AddressType = exports.ContactInfoType = exports.AuthorizedIdentityType = exports.Role = exports.CommissionStrategy = exports.Payout = exports.CommissionModel = exports.CancelReason = exports.PayType = exports.GroupStatus = exports.GroupAction = void 0;
var GroupAction;
(function (GroupAction) {
    GroupAction["CREATE"] = "CREATE";
    GroupAction["UPDATE"] = "UPDATE";
    GroupAction["ADD_AMENDMENTS"] = "ADD_AMENDMENTS";
    GroupAction["UPDATE_AMENDMENTS"] = "UPDATE_AMENDMENTS";
    GroupAction["ADD_AUTHORIZED_IDENTITIES"] = "ADD_AUTHORIZED_IDENTITIES";
    GroupAction["UPDATE_AUTHORIZED_IDENTITIES"] = "UPDATE_AUTHORIZED_IDENTITIES";
    GroupAction["ADD_ASSOCIATES"] = "ADD_ASSOCIATES";
    GroupAction["UPDATE_ASSOCIATES"] = "UPDATE_ASSOCIATES";
    GroupAction["ADD_OFFERS"] = "ADD_OFFERS";
    GroupAction["UPDATE_OFFERS"] = "UPDATE_OFFERS";
    GroupAction["DELETE"] = "DELETE";
    GroupAction["ACTIVATE"] = "ACTIVATE";
    GroupAction["PENDING"] = "PENDING";
    GroupAction["CANCEL"] = "CANCEL";
    GroupAction["ADD_ASSOCIATE"] = "ADD_ASSOCIATE";
    GroupAction["REMOVE_ASSOCIATE"] = "REMOVE_ASSOCIATE";
    GroupAction["ADD_AUTHORIZED_IDENTITY"] = "ADD_AUTHORIZED_IDENTITY";
    GroupAction["REMOVE_AUTHORIZED_IDENTITY"] = "REMOVE_AUTHORIZED_IDENTITY";
    GroupAction["ADD_OFFERID"] = "ADD_OFFERID";
    GroupAction["REMOVE_OFFERID"] = "REMOVE_OFFERID";
    GroupAction["UPDATE_COMMISSION"] = "UPDATE_COMMISSION";
    GroupAction["UPDATE_CONTACT_INFO"] = "UPDATE_CONTACT_INFO";
    GroupAction["UPDATE_ADDRESSES"] = "UPDATE_ADDRESSES";
    GroupAction["UPDATE_ENROLLMENT_CONFIG"] = "UPDATE_ENROLLMENT_CONFIG";
    GroupAction["UPDATE_PAYPERIODS"] = "UPDATE_PAYPERIODS";
    GroupAction["ADD_PAYPERIOD"] = "ADD_PAYPERIOD";
    GroupAction["REMOVE_PAYPERIOD"] = "REMOVE_PAYPERIOD";
    GroupAction["UPDATE_RESTRICTED_PERIODS"] = "UPDATE_RESTRICTED_PERIODS";
    GroupAction["ADD_RESTRICTED_PERIOD"] = "ADD_RESTRICTED_PERIOD";
    GroupAction["REMOVE_RESTRICTED_PERIOD"] = "REMOVE_RESTRICTED_PERIOD";
    GroupAction["UPDATE_RESTRICTED_EFFECTIVE_DATES"] = "UPDATE_RESTRICTED_EFFECTIVE_DATES";
    GroupAction["ADD_RESTRICTED_EFFECTIVE_DATE"] = "ADD_RESTRICTED_EFFECTIVE_DATE";
    GroupAction["REMOVE_RESTRICTED_EFFECTIVE_DATE"] = "REMOVE_RESTRICTED_EFFECTIVE_DATE";
    GroupAction["UPDATE_NAME"] = "UPDATE_NAME";
    GroupAction["UPDATE_COUNTRY_IDENTIFIER"] = "UPDATE_COUNTRY_IDENTIFIER";
    GroupAction["UPDATE_NUMBER_OF_EMPLOYEES"] = "UPDATE_NUMBER_OF_EMPLOYEES";
    GroupAction["UPDATE_ISNATIONAL"] = "UPDATE_ISNATIONAL";
    GroupAction["UPDATE_FRANCHISE"] = "UPDATE_FRANCHISE";
    GroupAction["UPDATE_PAYTYPE"] = "UPDATE_PAYTYPE";
    GroupAction["UPDATE_INDUSTRYTYPE"] = "UPDATE_INDUSTRYTYPE";
    GroupAction["UPDATE_EFFECTIVEAT"] = "UPDATE_EFFECTIVEAT";
    GroupAction["UPDATE_SERVICING"] = "UPDATE_SERVICING";
    GroupAction["UPDATE_ORIGINAL_DATE_OF_CREATION"] = "UPDATE_ORIGINAL_DATE_OF_CREATION";
    GroupAction["ADD_ASSOCIATE_ROLE"] = "ADD_ASSOCIATE_ROLE";
    GroupAction["REMOVE_ASSOCIATE_ROLE"] = "REMOVE_ASSOCIATE_ROLE";
    GroupAction["UPDATE_AUTHORIZED_IDENTITY_DIVISIONS"] = "UPDATE_AUTHORIZED_IDENTITY_DIVISIONS";
    GroupAction["UPDATE_COMMUNICATION_PREFERENCES"] = "UPDATE_COMMUNICATION_PREFERENCES";
    GroupAction["UPDATE_BROKER"] = "UPDATE_BROKER";
})(GroupAction = exports.GroupAction || (exports.GroupAction = {}));
var GroupStatus;
(function (GroupStatus) {
    GroupStatus["NONE"] = "NONE";
    GroupStatus["ACTIVE"] = "ACTIVE";
    GroupStatus["CANCELLED"] = "CANCELLED";
    GroupStatus["PENDING"] = "PENDING";
    GroupStatus["CREATED"] = "CREATED";
    GroupStatus["DELETED"] = "DELETED";
})(GroupStatus = exports.GroupStatus || (exports.GroupStatus = {}));
var PayType;
(function (PayType) {
    PayType["NONE"] = "NONE";
    PayType["SELF_PAY"] = "SELF_PAY";
    PayType["PAYROLL"] = "PAYROLL";
    PayType["FRINGE"] = "FRINGE";
    PayType["PARTIAL_FRINGE"] = "PARTIAL_FRINGE";
})(PayType = exports.PayType || (exports.PayType = {}));
var CancelReason;
(function (CancelReason) {
    CancelReason["NONE"] = "NONE";
    CancelReason["LACK_OF_PARTICIPATION"] = "LACK_OF_PARTICIPATION";
    CancelReason["COMBINED_WITH_OTHER_GROUPS"] = "COMBINED_WITH_OTHER_GROUPS";
    CancelReason["GROUP_DELINQUENT_STATUS"] = "GROUP_DELINQUENT_STATUS";
    CancelReason["FINANCIAL_REASON_OR_BANKRUPTCY"] = "FINANCIAL_REASON_OR_BANKRUPTCY";
    CancelReason["WRITTEN_REQUEST_FROM_GROUP"] = "WRITTEN_REQUEST_FROM_GROUP";
    CancelReason["NO_ACTIVE_MEMBERS"] = "NO_ACTIVE_MEMBERS";
    CancelReason["COMPANY_SOLD_OR_CLOSED"] = "COMPANY_SOLD_OR_CLOSED";
    CancelReason["TRANSFERRED"] = "TRANSFERRED";
    CancelReason["COMPANY_OPTION"] = "COMPANY_OPTION";
    CancelReason["FRINGE_CONTRACT"] = "FRINGE_CONTRACT";
    CancelReason["UNKNOWN"] = "UNKNOWN";
})(CancelReason = exports.CancelReason || (exports.CancelReason = {}));
var CommissionModel;
(function (CommissionModel) {
    CommissionModel["NONE"] = "NONE";
    CommissionModel["ALTERNATE"] = "ALTERNATE";
    CommissionModel["OVER200"] = "OVER_200";
    CommissionModel["STANDARD"] = "STANDARD";
})(CommissionModel = exports.CommissionModel || (exports.CommissionModel = {}));
var Payout;
(function (Payout) {
    Payout["NONE"] = "NONE";
    Payout["AS_EARNED"] = "AS_EARNED";
    Payout["PAYMENT_EARNINGS"] = "PAYMENT_EARNINGS";
    Payout["ADVANCE"] = "ADVANCE";
})(Payout = exports.Payout || (exports.Payout = {}));
var CommissionStrategy;
(function (CommissionStrategy) {
    CommissionStrategy["HIGH_LOW"] = "HIGH_LOW";
    CommissionStrategy["LEVEL"] = "LEVEL";
    CommissionStrategy["NONE"] = "NONE";
})(CommissionStrategy = exports.CommissionStrategy || (exports.CommissionStrategy = {}));
var Role;
(function (Role) {
    Role["NONE"] = "NONE";
    Role["CURRENT_SERVICING"] = "CURRENT_SERVICING";
    Role["AUTHORIZED"] = "AUTHORIZED";
    Role["DESIGNATED"] = "DESIGNATED";
    Role["ORIGINAL_SERVICING"] = "ORIGINAL_SERVICING";
    Role["NATIONAL_SALES_DIRECTOR"] = "NATIONAL_SALES_DIRECTOR";
    Role["FINDERS_FEE"] = "FINDERS_FEE";
    Role["PRODUCER"] = "PRODUCER";
    Role["FIELD_TRAINER"] = "FIELD_TRAINER";
    Role["ONLINE"] = "ONLINE";
})(Role = exports.Role || (exports.Role = {}));
var AuthorizedIdentityType;
(function (AuthorizedIdentityType) {
    AuthorizedIdentityType["GROUP_ADMINISTRATOR"] = "GROUP_ADMINISTRATOR";
    AuthorizedIdentityType["CUSTOMER_SERVICE_REPRESENTATIVE"] = "CUSTOMER_SERVICE_REPRESENTATIVE";
    AuthorizedIdentityType["AUTHORIZED_USER"] = "AUTHORIZED_USER";
    AuthorizedIdentityType["FILE_ADMINISTRATOR"] = "FILE_ADMINISTRATOR";
})(AuthorizedIdentityType = exports.AuthorizedIdentityType || (exports.AuthorizedIdentityType = {}));
var ContactInfoType;
(function (ContactInfoType) {
    ContactInfoType["PRIMARY"] = "PRIMARY";
    ContactInfoType["COMPANY"] = "COMPANY";
})(ContactInfoType = exports.ContactInfoType || (exports.ContactInfoType = {}));
var AddressType;
(function (AddressType) {
    AddressType["MAILING"] = "MAILING";
    AddressType["BILLING"] = "BILLING";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var EnrollmentConfigDefaultEnrollmentMethod;
(function (EnrollmentConfigDefaultEnrollmentMethod) {
    EnrollmentConfigDefaultEnrollmentMethod["NONE"] = "NONE";
    EnrollmentConfigDefaultEnrollmentMethod["FILE"] = "FILE";
    EnrollmentConfigDefaultEnrollmentMethod["CHECKOUT"] = "CHECKOUT";
    EnrollmentConfigDefaultEnrollmentMethod["PAPER"] = "PAPER";
})(EnrollmentConfigDefaultEnrollmentMethod = exports.EnrollmentConfigDefaultEnrollmentMethod || (exports.EnrollmentConfigDefaultEnrollmentMethod = {}));
var EnrollmentMarketingSiteType;
(function (EnrollmentMarketingSiteType) {
    EnrollmentMarketingSiteType["NONE"] = "NONE";
    EnrollmentMarketingSiteType["CHECKOUT"] = "CHECKOUT";
    EnrollmentMarketingSiteType["WEB"] = "WEB";
})(EnrollmentMarketingSiteType = exports.EnrollmentMarketingSiteType || (exports.EnrollmentMarketingSiteType = {}));
var EnrollmentConfigFrequency;
(function (EnrollmentConfigFrequency) {
    EnrollmentConfigFrequency["NONE"] = "NONE";
    EnrollmentConfigFrequency["EVERGREEN"] = "EVERGREEN";
    EnrollmentConfigFrequency["OPEN_ENROLLMENT"] = "OPEN_ENROLLMENT";
    EnrollmentConfigFrequency["OPEN_ENROLLMENT_WITH_NEW_HIRES"] = "OPEN_ENROLLMENT_WITH_NEW_HIRES";
    EnrollmentConfigFrequency["SCHEDULED"] = "SCHEDULED";
    EnrollmentConfigFrequency["OPEN"] = "OPEN";
})(EnrollmentConfigFrequency = exports.EnrollmentConfigFrequency || (exports.EnrollmentConfigFrequency = {}));
var ReviewType;
(function (ReviewType) {
    ReviewType["INACTIVE"] = "INACTIVE";
    ReviewType["ACTIVE"] = "ACTIVE";
    ReviewType["REVIEW"] = "REVIEW";
    ReviewType["TEST"] = "TEST";
})(ReviewType = exports.ReviewType || (exports.ReviewType = {}));
var FileType;
(function (FileType) {
    FileType["NONE"] = "NONE";
    FileType["FULL"] = "FULL";
    FileType["ADD_DROP_CHANGE"] = "ADD_DROP_CHANGE";
})(FileType = exports.FileType || (exports.FileType = {}));
var FileSchedule;
(function (FileSchedule) {
    FileSchedule["NONE"] = "NONE";
    FileSchedule["AD_HOC"] = "AD_HOC";
    FileSchedule["ANNUAL"] = "ANNUAL";
    FileSchedule["BI_WEEKLY"] = "BI_WEEKLY";
    FileSchedule["DAILY"] = "DAILY";
    FileSchedule["MONTHLY"] = "MONTHLY";
    FileSchedule["ONE_TIME_FILE"] = "ONE_TIME_FILE";
    FileSchedule["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    FileSchedule["SEMI_MONTHLY"] = "SEMI_MONTHLY";
    FileSchedule["QUARTERLY"] = "QUARTERLY";
    FileSchedule["WEEKLY"] = "WEEKLY";
})(FileSchedule = exports.FileSchedule || (exports.FileSchedule = {}));
var Transmission;
(function (Transmission) {
    Transmission["NONE"] = "NONE";
    Transmission["BENEFITFOCUS_SITE"] = "BENEFITFOCUS_SITE";
    Transmission["BRICK_USER"] = "BRICK_USER";
    Transmission["BRICKFTP"] = "BRICKFTP";
    Transmission["PGP"] = "PGP";
    Transmission["PW_PROTECTED_FILE"] = "PW_PROTECTED_FILE";
    Transmission["SECURE_EMAIL"] = "SECURE_EMAIL";
    Transmission["SFTP"] = "SFTP";
})(Transmission = exports.Transmission || (exports.Transmission = {}));
var Format;
(function (Format) {
    Format["NONE"] = "NONE";
    Format["CSV"] = "CSV";
    Format["EMPLOYEE_NAVIGATOR"] = "EMPLOYEE_NAVIGATOR";
    Format["EXCEL"] = "EXCEL";
    Format["IMAX"] = "IMAX";
    Format["TEXT"] = "TEXT";
})(Format = exports.Format || (exports.Format = {}));
var RestrictedPeriodType;
(function (RestrictedPeriodType) {
    RestrictedPeriodType["OPEN"] = "OPEN";
    RestrictedPeriodType["SCHEDULED"] = "SCHEDULED";
    RestrictedPeriodType["NONE"] = "NONE";
    RestrictedPeriodType["EVERGREEN"] = "EVERGREEN";
    RestrictedPeriodType["OPEN_ENROLLMENT"] = "OPEN_ENROLLMENT";
})(RestrictedPeriodType = exports.RestrictedPeriodType || (exports.RestrictedPeriodType = {}));
var RestrictedEffectiveDateEnrollmentSource;
(function (RestrictedEffectiveDateEnrollmentSource) {
    RestrictedEffectiveDateEnrollmentSource["FILE_TRANSFER"] = "FILE_TRANSFER";
    RestrictedEffectiveDateEnrollmentSource["LS_AT_WORK"] = "LS_AT_WORK";
    RestrictedEffectiveDateEnrollmentSource["PAPER"] = "PAPER";
    RestrictedEffectiveDateEnrollmentSource["WEB"] = "WEB";
    RestrictedEffectiveDateEnrollmentSource["ALL"] = "ALL";
})(RestrictedEffectiveDateEnrollmentSource = exports.RestrictedEffectiveDateEnrollmentSource || (exports.RestrictedEffectiveDateEnrollmentSource = {}));
var RestrictedEffectiveDateStatus;
(function (RestrictedEffectiveDateStatus) {
    RestrictedEffectiveDateStatus["ACTIVE"] = "ACTIVE";
    RestrictedEffectiveDateStatus["INACTIVE"] = "INACTIVE";
})(RestrictedEffectiveDateStatus = exports.RestrictedEffectiveDateStatus || (exports.RestrictedEffectiveDateStatus = {}));
var RestrictedEffectiveDateEffectiveMonth;
(function (RestrictedEffectiveDateEffectiveMonth) {
    RestrictedEffectiveDateEffectiveMonth["CURRENT_MONTH"] = "CURRENT_MONTH";
    RestrictedEffectiveDateEffectiveMonth["CURRENT_PLUS_ONE_MONTH"] = "CURRENT_PLUS_ONE_MONTH";
    RestrictedEffectiveDateEffectiveMonth["CURRENT_PLUS_TWO_MONTH"] = "CURRENT_PLUS_TWO_MONTH";
    RestrictedEffectiveDateEffectiveMonth["CURRENT_PLUS_THREE_MONTH"] = "CURRENT_PLUS_THREE_MONTH";
})(RestrictedEffectiveDateEffectiveMonth = exports.RestrictedEffectiveDateEffectiveMonth || (exports.RestrictedEffectiveDateEffectiveMonth = {}));
var CommunicationPreferenceType;
(function (CommunicationPreferenceType) {
    CommunicationPreferenceType["LETTER"] = "LETTER";
    CommunicationPreferenceType["EMAIL"] = "EMAIL";
    CommunicationPreferenceType["BOTH"] = "BOTH";
})(CommunicationPreferenceType = exports.CommunicationPreferenceType || (exports.CommunicationPreferenceType = {}));
var BrokerType;
(function (BrokerType) {
    BrokerType["BROKER"] = "BROKER";
    BrokerType["TOP_BROKER"] = "TOP_BROKER";
})(BrokerType = exports.BrokerType || (exports.BrokerType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://groups.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Groups API
 * @version v1
 * @baseUrl https://groups.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags GroupsJournal
             * @name GroupsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/groups/journal
             * @secure
             */
            groupsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupsJournal
             * @name GroupsJournalGetJournalMaxClock
             * @request GET:/v1/groups/journal/maxClock
             * @secure
             */
            groupsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsGetGroupById
             * @request GET:/v1/groups/{groupId}
             * @secure
             */
            groupsGetGroupById: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsDeleteGroup
             * @request DELETE:/v1/groups/{groupId}
             * @secure
             */
            groupsDeleteGroup: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsGetGroupByOwner
             * @request GET:/v1/groups
             * @secure
             */
            groupsGetGroupByOwner: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsCreateGroup
             * @request POST:/v1/groups
             * @secure
             */
            groupsCreateGroup: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsPending
             * @request POST:/v1/groups/{groupId}/pending
             * @secure
             */
            groupsPending: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/pending`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsActivate
             * @request POST:/v1/groups/{groupId}/activate
             * @secure
             */
            groupsActivate: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsCancel
             * @request POST:/v1/groups/{groupId}/cancel
             * @secure
             */
            groupsCancel: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/cancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateName
             * @request POST:/v1/groups/{groupId}/updateName
             * @secure
             */
            groupsUpdateName: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateCountryIdentifier
             * @request POST:/v1/groups/{groupId}/updateCountryIdentifier
             * @secure
             */
            groupsUpdateCountryIdentifier: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateCountryIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateEffectiveAt
             * @request POST:/v1/groups/{groupId}/updateEffectiveAt
             * @secure
             */
            groupsUpdateEffectiveAt: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateEffectiveAt`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateOriginalDateOfCreation
             * @request POST:/v1/groups/{groupId}/updateOriginalDateOfCreation
             * @secure
             */
            groupsUpdateOriginalDateOfCreation: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateOriginalDateOfCreation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateNumberOfEmployees
             * @request POST:/v1/groups/{groupId}/updateNumberOfEmployees
             * @secure
             */
            groupsUpdateNumberOfEmployees: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateNumberOfEmployees`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateIsNational
             * @request POST:/v1/groups/{groupId}/updateIsNational
             * @secure
             */
            groupsUpdateIsNational: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateIsNational`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateFranchise
             * @request POST:/v1/groups/{groupId}/updateFranchise
             * @secure
             */
            groupsUpdateFranchise: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateFranchise`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateServicing
             * @request POST:/v1/groups/{groupId}/updateServicing
             * @secure
             */
            groupsUpdateServicing: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateServicing`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdatePayType
             * @request POST:/v1/groups/{groupId}/updatePayType
             * @secure
             */
            groupsUpdatePayType: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updatePayType`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateIndustryType
             * @request POST:/v1/groups/{groupId}/updateIndustryType
             * @secure
             */
            groupsUpdateIndustryType: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateIndustryType`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAssociate
             * @request POST:/v1/groups/{groupId}/addAssociate
             * @secure
             */
            groupsAddAssociate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAssociate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAssociate
             * @request POST:/v1/groups/{groupId}/removeAssociate
             * @secure
             */
            groupsRemoveAssociate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAssociate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAssociateRole
             * @request POST:/v1/groups/{groupId}/addAssociateRole
             * @secure
             */
            groupsAddAssociateRole: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAssociateRole`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAssociateRole
             * @request POST:/v1/groups/{groupId}/removeAssociateRole
             * @secure
             */
            groupsRemoveAssociateRole: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAssociateRole`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAuthorizedIdentity
             * @request POST:/v1/groups/{groupId}/addAuthorizedIdentity
             * @secure
             */
            groupsAddAuthorizedIdentity: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAuthorizedIdentity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAuthorizedIdentity
             * @request POST:/v1/groups/{groupId}/removeAuthorizedIdentity
             * @secure
             */
            groupsRemoveAuthorizedIdentity: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAuthorizedIdentity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateAuthorizedIdentityDivisions
             * @request POST:/v1/groups/{groupId}/updateAuthorizedIdentityDivisions
             * @secure
             */
            groupsUpdateAuthorizedIdentityDivisions: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateAuthorizedIdentityDivisions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddOfferId
             * @request POST:/v1/groups/{groupId}/addOfferId
             * @secure
             */
            groupsAddOfferId: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addOfferId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveOfferId
             * @request POST:/v1/groups/{groupId}/removeOfferId
             * @secure
             */
            groupsRemoveOfferId: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeOfferId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAmendment
             * @request POST:/v1/groups/{groupId}/addAmendment
             * @secure
             */
            groupsAddAmendment: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAmendment`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAmendment
             * @request POST:/v1/groups/{groupId}/removeAmendment
             * @secure
             */
            groupsRemoveAmendment: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAmendment`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateCommission
             * @request POST:/v1/groups/{groupId}/updateCommission
             * @secure
             */
            groupsUpdateCommission: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateCommission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddContactInfo
             * @request POST:/v1/groups/{groupId}/addContactInfo
             * @secure
             */
            groupsAddContactInfo: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addContactInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveContactInfo
             * @request POST:/v1/groups/{groupId}/removeContactInfo
             * @secure
             */
            groupsRemoveContactInfo: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeContactInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAddress
             * @request POST:/v1/groups/{groupId}/addAddress
             * @secure
             */
            groupsAddAddress: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAddress
             * @request POST:/v1/groups/{groupId}/removeAddress
             * @secure
             */
            groupsRemoveAddress: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateEnrollmentConfig
             * @request POST:/v1/groups/{groupId}/updateEnrollmentConfig
             * @secure
             */
            groupsUpdateEnrollmentConfig: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateEnrollmentConfig`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddPayPeriod
             * @request POST:/v1/groups/{groupId}/addPayPeriod
             * @secure
             */
            groupsAddPayPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addPayPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemovePayPeriod
             * @request POST:/v1/groups/{groupId}/removePayPeriod
             * @secure
             */
            groupsRemovePayPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removePayPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddRestrictedPeriod
             * @request POST:/v1/groups/{groupId}/addRestrictedPeriod
             * @secure
             */
            groupsAddRestrictedPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addRestrictedPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveRestrictedPeriod
             * @request POST:/v1/groups/{groupId}/removeRestrictedPeriod
             * @secure
             */
            groupsRemoveRestrictedPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeRestrictedPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddSpecificRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/addSpecificRestrictedEffectiveDate
             * @secure
             */
            groupsAddSpecificRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addSpecificRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveSpecificRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/removeSpecificRestrictedEffectiveDate
             * @secure
             */
            groupsRemoveSpecificRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeSpecificRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddOngoingRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/addOngoingRestrictedEffectiveDate
             * @secure
             */
            groupsAddOngoingRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addOngoingRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveOngoingRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/removeOngoingRestrictedEffectiveDate
             * @secure
             */
            groupsRemoveOngoingRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeOngoingRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateCommunicationPreferences
             * @request POST:/v1/groups/{groupId}/updateCommunicationPreferences
             * @secure
             */
            groupsUpdateCommunicationPreferences: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateCommunicationPreferences`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateBroker
             * @request POST:/v1/groups/{groupId}/updateBroker
             * @secure
             */
            groupsUpdateBroker: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateBroker`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates an group in place
             *
             * @tags Migration
             * @name MachineJwtOnly
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate
             * @secure
             */
            machineJwtOnly: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates an group in place
             *
             * @tags Migration
             * @name MachineJwtOnly2
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate/{groupId}/addAuthorizedIdentities
             * @secure
             */
            machineJwtOnly2: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate/${groupId}/addAuthorizedIdentities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates a group in place
             *
             * @tags Migration
             * @name MachineJwtOnly3
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate/{groupId}/addAssociates
             * @secure
             */
            machineJwtOnly3: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate/${groupId}/addAssociates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates a group in place
             *
             * @tags Migration
             * @name MachineJwtOnly4
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate/{groupId}/addOffers
             * @secure
             */
            machineJwtOnly4: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate/${groupId}/addOffers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=groups.js.map